export default "__VITE_ASSET__Dulh4q08__"